/* MEDIA PLAYER SURFACE *******************************************************/

// libs
import _ from 'lodash'
import Cookies from 'js-cookie'

// utils
import { randomString } from 'util/string'
import { getDuration } from 'util/asset'

// rest webservice api abstraction
import * as api from 'api'

// selectors
import { getItem, getSurfaceItem } from 'react-redux/selectors/media-player'
import { getItem as getAssetItem } from 'react-redux/selectors/asset'

import {
  fetchItems as fetchPlaylistItems,
  fetchSingleStats as fetchPlaylistStats
} from 'react-redux/actions/playlist'
import { hideModal } from 'react-redux/actions/modal'
import {
  fetchSurface,
  fetchSurfaces,
  setSyncHint
} from 'react-redux/actions/media-player'
import {
  push as pushNotification,
  pull as pullNotification
} from 'react-redux/actions/notification'

import { makePlaylistPayload, makeEmptyPlaylist, makeMediaObject } from 'react-redux/actions/playlist'

// constants
import * as notificationType from 'component/notification/type'


import { SUCCESS_SUFFIX, FAIL_SUFFIX, PROGRESS_SUFFIX } from 'util/dataprovider'
import { makeAction } from 'util/reduxhelper'


/* HELPERS ********************************************************************/


const isValidSurface = (surfaces, mediaPlayerId, surfaceId) => {
  return surfaces[mediaPlayerId] && surfaces[mediaPlayerId][surfaceId]
}

export const makeSurfacePayload = (getState, mediaPlayerId, surfaceId) => {
  return _.cloneDeep(
   _.pick(
     getSurfaceItem(getState(), surfaceId),
     ["surfaceName", "playlistId"]
   )
 )
}

/* REMOVE PLAYLIST ASSIGNMENT *************************************************/

export const REMOVE_ASSIGNMENT = 'mediaPlayer/surface/REMOVE_ASSIGNMENT'
export const removeAssignment = (mediaPlayerId, surfaceId) => {
  return (dispatch, getState) => {
    const surface = makeSurfacePayload(getState, mediaPlayerId, surfaceId)
    const previousPlaylistId = surface.playlistId
    surface.playlistId = null
    dispatch(makeAction(REMOVE_ASSIGNMENT, {mediaPlayerId, surfaceId, surface}, {previousPlaylistId}))
  }
}
/* automated for convenience @see dataprovider */
export const REMOVE_ASSIGNMENT_FAIL = REMOVE_ASSIGNMENT + FAIL_SUFFIX
export const REMOVE_ASSIGNMENT_SUCCESS = REMOVE_ASSIGNMENT + SUCCESS_SUFFIX


/* ASSIGN PLAYLIST ************************************************************/

export const ASSIGN_PLAYLIST = 'mediaPlayer/surface/ASSIGN_PLAYLIST'
export const assignPlaylist = (mediaPlayerId, surfaceId, playlistId) => {
  return (dispatch, getState) => {
    const surface = makeSurfacePayload(getState, mediaPlayerId, surfaceId)
    const previousPlaylistId = surface.playlistId
    surface.playlistId = playlistId
    dispatch(makeAction(ASSIGN_PLAYLIST, {mediaPlayerId, surfaceId, surface}, {previousPlaylistId}))
  }
}
/* automated for convenience @see dataprovider */
export const ASSIGN_PLAYLIST_FAIL = ASSIGN_PLAYLIST + FAIL_SUFFIX
export const ASSIGN_PLAYLIST_SUCCESS = ASSIGN_PLAYLIST + SUCCESS_SUFFIX

/* WRAP PLAYLIST AROUND ASSET AND ASSIGN IT ***********************************/

export const WRAP_ASSET_AND_ASSIGN_PLAYLIST = 'mediaPlayer/surface/WRAP_ASSET_AND_ASSIGN_PLAYLIST'
export const wrapAssetAndAssignPlaylist = (
  mediaPlayerId,
  surfaceId,
  assetId
) => {
  return (dispatch, getState) => {
    const asset = getAssetItem(getState(), assetId)
    const playlist = makeEmptyPlaylist(asset.name)
    playlist.mediaObjects.push(makeMediaObject(getState, assetId))
    dispatch(makeAction(WRAP_ASSET_AND_ASSIGN_PLAYLIST, playlist, {mediaPlayerId, surfaceId}))
  }
}
/* automated for convenience @see dataprovider */
export const WRAP_ASSET_AND_ASSIGN_PLAYLIST_FAIL = WRAP_ASSET_AND_ASSIGN_PLAYLIST + FAIL_SUFFIX
export const WRAP_ASSET_AND_ASSIGN_PLAYLIST_SUCCESS = WRAP_ASSET_AND_ASSIGN_PLAYLIST + SUCCESS_SUFFIX


/* ASSIGN PLAYLIST TO ALL SURFACES ********************************************/

export const ASSIGN_GLOBAL_PLAYLIST = 'mediaPlayer/surface/ASSIGN_GLOBAL_PLAYLIST'
export const assignGlobalPlaylist = (mediaPlayerId, playlistId) => {
  return (dispatch, getState) => {
    const mediaplayerSurfaces = getState().mediaPlayer.list.surfaces[mediaPlayerId]
    const previousPlaylists = []
    const surfaces  = {}
    for (var k in mediaplayerSurfaces) {
      surfaces[k] = makeSurfacePayload(getState, mediaPlayerId, k)
      previousPlaylists.push(surfaces[k].playlistId)
      surfaces[k].playlistId = playlistId
    }
    dispatch(makeAction(ASSIGN_GLOBAL_PLAYLIST, {mediaPlayerId, surfaces}, { previousPlaylists }))
  }
}
/* automated for convenience @see dataprovider */
// Currently not in use, since server api endpoint is unavailable
export const ASSIGN_GLOBAL_PLAYLIST_FAIL = ASSIGN_GLOBAL_PLAYLIST + FAIL_SUFFIX
export const ASSIGN_GLOBAL_PLAYLIST_SUCCESS = ASSIGN_GLOBAL_PLAYLIST + SUCCESS_SUFFIX


/* ASSIGN ASSET TO ALL SURFACES ********************************************/

export const WRAP_ASSET_AND_ASSIGN_GLOBAL_PLAYLIST = 'mediaPlayer/surface/WRAP_ASSET_AND_ASSIGN_GLOBAL_PLAYLIST'
export const wrapAssetAndAssignGlobalPlaylist = (mediaPlayerId, assetId) => {
  return (dispatch, getState) => {
    const asset = getAssetItem(getState(), assetId)
    const playlist = makeEmptyPlaylist(asset.name)
    playlist.mediaObjects.push(makeMediaObject(getState, assetId))
    dispatch(makeAction(WRAP_ASSET_AND_ASSIGN_GLOBAL_PLAYLIST, playlist, {mediaPlayerId}))
  }
}
export const WRAP_ASSET_AND_ASSIGN_GLOBAL_PLAYLIST_FAIL = WRAP_ASSET_AND_ASSIGN_GLOBAL_PLAYLIST + FAIL_SUFFIX
export const WRAP_ASSET_AND_ASSIGN_GLOBAL_PLAYLIST_SUCCESS = WRAP_ASSET_AND_ASSIGN_GLOBAL_PLAYLIST + SUCCESS_SUFFIX


/* CHANGE SURFACE NAME ********************************************************/

export const SAVE_NAME = 'mediaPlayer/surface/SAVE_NAME'
export const saveName = (mediaPlayerId, surfaceId, surfaceName) => {
  return (dispatch, getState) => {
    const surface = makeSurfacePayload(getState, mediaPlayerId, surfaceId)
    surface.surfaceName = surfaceName
    dispatch(makeAction(SAVE_NAME, {mediaPlayerId, surfaceId, surface}))
  }
}
export const SAVE_NAME_FAIL = SAVE_NAME + FAIL_SUFFIX
export const SAVE_NAME_SUCCESS = SAVE_NAME + SUCCESS_SUFFIX



// WEBPACK FOOTER //
// ./src/app/react-redux/actions/surface.js